var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMask = function SvgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.139 16.124c-1.074 0-1.945.84-1.945 1.875s.871 1.875 1.945 1.875 1.944-.84 1.944-1.875-.87-1.875-1.944-1.875M3.25 17.999c0-2.071 1.741-3.75 3.889-3.75 1.44 0 2.696.754 3.369 1.875h2.985a3.92 3.92 0 0 1 3.368-1.875c2.148 0 3.889 1.679 3.889 3.75s-1.741 3.75-3.889 3.75-3.889-1.679-3.889-3.75h-1.944c0 2.071-1.741 3.75-3.89 3.75-2.147 0-3.888-1.679-3.888-3.75m13.611-1.875c-1.074 0-1.944.84-1.944 1.875s.87 1.875 1.944 1.875 1.945-.84 1.945-1.875-.871-1.875-1.945-1.875",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.316 4.596C5.61 2.71 7.673 1.663 9.353 2.592l.615.34c1.267.7 2.797.7 4.063 0l.615-.34c1.681-.929 3.744.118 4.037 2.004l1.058 6.788a.75.75 0 0 1-.894.85c-2.115-.44-7.88-1.068-13.712.003a.75.75 0 0 1-.876-.853z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 11.999c-3.774 0-7.104.66-9.335 1.658-.483.216-1.07.04-1.311-.392s-.046-.958.437-1.174c2.57-1.15 6.218-1.842 10.21-1.842 3.991 0 7.639.692 10.209 1.842.483.216.678.742.437 1.174s-.828.608-1.31.392c-2.232-.999-5.562-1.658-9.336-1.658Z",
    clipRule: "evenodd"
  })));
};
export default SvgMask;